<template>
  <div>
    <div class="modal fade" id="publishWizardModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmModalLabel">Publish Website</h5>
            <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

            </button>
          </div>
          <div v-if="model.website.id" class="modal-body">

            <div v-if="step === 'NetlifySetup'" class="card mb-2">

              <div class="card-body">
                <p class="card-text">WeBase uses Netlify for custom domain hosting.</p>
                <h5 class="card-title"><strong>Please connect to a free Netlify account</strong></h5>

                <div class="border rounded p-2" style="border-color: #2bbbb8 !important;">
                  <a :href="netlifyUrl">
                    <netlify></netlify>
                  </a>
                </div>

              </div>
            </div>

            <div v-else class="alert alert-success mb-3" role="alert">
              Netlify Setup Complete
            </div>

            <div v-if="step !== 'NetlifySetup'" class="mb-3">
              <checkbox-control :object="model" field="isCustomDomain" label="Publish to a custom domain"></checkbox-control>
            </div>

            <div v-if="model.isCustomDomain">

              <form v-if="step !== 'NetlifySetup'">
                <div class="row mb-3">
                  <div class="col-12">
                    <input id="customDomainInput" type="text" class="form-control"
                           placeholder="custom domain"
                           v-model="model.website.custom_domain">
                  </div>
                </div>

                <div v-if="step === 'AddCustomDomain'" class="form-group">
                  <button type="button" class="btn btn-sm btn-primary" @click="onSaveClick">next</button>
                </div>

              </form>

              <div v-if="step === 'DNSSetup' && model.website.metadata.netlifyDns" class="alert alert-warning"
                   role="alert">
                Please update your name servers at the registrar of your domain to use these values:
                <br><br>

                <div v-for="dns_server in model.website.metadata.netlifyDns.dns_servers">
                  <strong>{{ dns_server }}</strong><br>
                </div>

                <div class="mb-3 mt-2">
                  <button type="button" class="btn btn-sm btn-primary" @click="onCheckDnsClick">Check DNS
                  </button>
                </div>

                <p v-if="dnsCheckMessage">
                  {{ dnsCheckMessage }}
                </p>
              </div>

              <div v-if="step === 'Setup Complete'" class="alert alert-success" role="alert">
                DNS Setup Complete
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="yesHandler">Publish</button>
            <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SiteService from "../../services/SiteService";
import Netlify from "../../integrations/Netlify.vue";
import CheckboxControl from "../../components/CheckboxControl.vue";

export default {
    name: 'PublishWizardModal',
    components: {CheckboxControl, Netlify},
    props: {
        yesEvent: Function,
        pageId: String
    },
    data() {
        return {
            model: webase.model,
            service: new SiteService(),
            step: null,
            app: webase.model.app,
            errorMessage: null,
            dnsCheckMessage: null,
            currentModal: null,
            modalElement: null,
        }
    },
    computed: {
        hasDnsZone() {
            return !!this.model.website.metadata.netlifyDns
        },
        hasNetlifySite() {
            return !!this.model.website.metadata.netlifySiteId
        },
        hasSSLConfigured() {
            return this.model.website.metadata.netlifySsl !== undefined
        },
        hasNetlifyIntegration() {

            if (this.app && webase.managers.app && webase.managers.app.hasIntegration('Netlify')) {
                return true
            }

            if (this.hasNetlifySite) {
                return true
            }

            return false
        },
        netlifyIntegration() {
            return webase.managers.app.getIntegration('Netlify')
        },
        netlifyUrl() {
            let url = 'https://app.netlify.com/authorize?client_id=' + this.netlifyClientId + '&response_type=code'
            return url + '&redirect_uri=' + this.netlifyRedirectUri + '&page_id=' + this.pageId + '&publish=true'
        },

        netlifyRedirectUri() {
            if (process.env.NODE_ENV === 'development') {
                return 'http://localhost:3000/auth/callback/netlify'
            }

            return 'https://www.webase.com/auth/callback/netlify'
        },

        netlifyClientId() {
            if (process.env.NODE_ENV === 'development') {
                return 'DXXFjrswBWaAm8UsXptl3eLR1e7j-DT68yWW9ccdYA8'
            }

            return '129b258d256c94900cf106c9c2ddc772f8ddc0032962c194af2bb32208427947'
        }
    },
    mounted() {
        this.modalElement = document.getElementById('publishWizardModal')
        this.currentModal = new bootstrap.Modal(this.modalElement)
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
        this.currentModal.show()
        this.model.isCustomDomain = !!this.model.website.custom_domain
        this.setCurrentStep()
    },
    beforeUnmount() {
        this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
    },
    methods: {
        onModalHidden() {
            this.$emit('noEvent')
        },
        noHandler(e) {
            this.currentModal.hide()
        },
        yesHandler(e) {
            if (this.yesEvent && this.hasNetlifyIntegration && this.hasNetlifySite) {
                this.yesEvent()
            }

            this.noHandler()
        },
        setCurrentStep() {
            if (!this.hasNetlifyIntegration) {
                this.step = 'NetlifySetup'
            } else if (!this.model.website.custom_domain) {
                this.step = 'AddCustomDomain'
            } else if (this.hasSSLConfigured) {
                this.step = 'Setup Complete'
            } else {
                this.step = 'DNSSetup'
            }
        },
        onSaveClick() {
            this.model.loading = true

            let request = {
                website: {
                    custom_domain: this.model.website.custom_domain
                }
            }

            this.service.update(this.model.website.slug, request).then((response) => {
                this.model.website = this.model.website = response

                if (this.hasDnsZone) {
                    this.step = 'DNSSetup'
                }

                this.model.loading = false

            }).catch((message) => {
                webase.utils.notification.error(message)
                this.model.loading = false
            })

        },

        onCheckDnsClick() {

            this.dnsCheckMessage = null
            this.model.loading = true
            this.service.deploySite(this.model.website.id).then((deployment) => {

                if (deployment['code'] === 404) {
                    let metadata = this.model.website.metadata
                    delete metadata.netlifySiteId
                    this.model.loading = false
                } else {
                    this.service.get(this.model.website.id).then((website) => {
                        this.model.website = website
                        this.setCurrentStep()

                        this.model.loading = false

                        if (this.step === 'DNSSetup') {
                            this.dnsCheckMessage = 'It can take some time for your DNS settings to fully propagate after you set them up.  Please check back soon!'
                        }

                    })
                }

            }).catch((error) => {
                console.log('Error deploying website.')
                console.log(error)
                this.model.loading = false
            })
        }
    }
}
</script>
